import { BrowserRouter as Router, Routes, Route, useLocation } from "react-router-dom";
import Home from "./pages/Home";
import About from "./pages/About";
import Domains from "./pages/Domains";
import DomainRegister from "./pages/DomainRegister";
import Login from "./pages/Login";
import Checkout from "./pages/Checkout";
import NotFound from "./pages/NotFound";
import Search from "./pages/Search/Search";
import EmailHosting from "./pages/EmailHosting";
import Marketing from "./pages/Marketing";
import Websites from "./pages/Websites";
import WordPressHosting from "./pages/WordPressHosting/WordPressHosting";
import WindowsHosting from "./pages/WindowsHosting/WindowsHosting";
import LinuxHosting from "./pages/LinuxHosting/LinuxHosting";
import DomainSearchResults from "./pages/DomainSearchResults/DomainSearchResults";
import ProjectDetail from "./pages/Projects/ProjectDetail";
import { useSmoothScroll } from "./hooks/useSmoothScroll";
import Newsroom from "./pages/Newsroom";
import Support from "./pages/Support";
import Voip from "./pages/3CX";
import EcommerceSolution from "./pages/EcommerceSolution";
import LogTicket from "./pages/LogTicket";
import RequestForServices from "./pages/RequestForServices";
import ItServicePackage from "./pages/ItServicePackage";
import Contact from "./pages/Contact";
import AiSolutions from "./pages/AiSolutions";
import CloudSolutions from "./pages/CloudSolutions";
import UIUXDesign from "./pages/UIUXDesign";
import CyberSecurity from "./pages/CyberSecurity";
import Careers from "./pages/Careers";
import JobDetailPage from "./pages/JobDetail";
import BlogDetailPage from "./pages/BlogDetail";
import TestPage from "./pages/TestPage";
import PageTransition from "./components/common/animations/PageTransition";
import { GoToTopButton } from "./components/common/ui/GoToTopButton";
import PrivacyPolicy from "./pages/PrivacyPolicy";
import TermandCondition from "./pages/TermandCondition";
import WebHosting from "./pages/WebHosting/WebHosting";
import WindowsServer from "./pages/WindowsServer/WindowsServer";
import EmailExchange from "./pages/EmailExchange/EmailExchange";
import SimpleSeo from "./pages/SimpleSeo/SimpleSeo";
import Loader from "./components/common/ui/Loader";
import { AnimatePresence } from "framer-motion";
import React from "react";
import Sidebar from "./components/common/layout/Sidebar";
import ForgotPassword from "./pages/ForgotPassword/ForgotPassword";
import RefernAndEarn from "./pages/ReferAndEarn";
import Nas from "./pages/NAS";
import ItConsulting from "./pages/ITConsulting";
import Profile from "./pages/Profile/Profile";
import ScrollToTop from "./components/common/ui/scrollToTop/scrolltotop";
import ApplicationDevelopment from "./pages/ApplicationDevelopment";


function AppRoutes() {
  const location = useLocation();

  return (
    <PageTransition>
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Home />} />
        <Route path="/about" element={<About />} />
        <Route path="/domains" element={<Domains />} />
        <Route path="/domains/search" element={<DomainSearchResults />} />
        <Route path="/domains/register" element={<DomainRegister />} />
        <Route path="/login" element={<Login />} />
        <Route path="/checkout" element={<Checkout />} />
        <Route path="/forgot-password" element={<ForgotPassword />} />
        <Route path="/email-hosting" element={<EmailHosting />} />
        <Route path="/marketing" element={<Marketing />} />
        <Route path="/search" element={<Search />} />
        <Route path="/websites" element={<Websites />} />
        <Route path="/wordpress-hosting" element={<WordPressHosting />} />
        <Route path="/windows-hosting" element={<WindowsHosting />} />
        <Route path="/web-hosting" element={<WebHosting />} />
        <Route path="/servers" element={<LinuxHosting />} />
        <Route path="/support" element={<Support />} />
        <Route path="/social" element={<Social />} />
        <Route path="/voip-service" element={<Voip />} />
        <Route path="/e-commerce-solutions" element={<EcommerceSolution />} />
        <Route path="/log-ticket" element={<LogTicket />} />
        <Route path="/request-for-services" element={<RequestForServices />} />
        <Route path="/it-service-package" element={<ItServicePackage />} />
        <Route path="/contact-us" element={<Contact />} />
        <Route path="/ai-solutions" element={<AiSolutions />} />
        <Route path="/cloud-solutions" element={<CloudSolutions />} />
        <Route path="/ui-ux-design" element={<UIUXDesign />} />
        <Route path="/cybersecurity-services" element={<CyberSecurity />} />
        <Route path="/careers" element={<Careers />} />
        <Route path="/careers/:jobId" element={<JobDetailPage />} />
        <Route path="/newsroom" element={<Newsroom />} />
        <Route path="/newsroom/:slug" element={<BlogDetailPage />} />
        <Route path="/test" element={<TestPage />} />
        <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        <Route path="/term-and-condition" element={<TermandCondition />} />
        <Route path="/windows-servers" element={<WindowsServer />} />
        <Route path="/email-exchange" element={<EmailExchange />} />
        <Route path="/simple-seo" element={<SimpleSeo />} />
        <Route path="/refer-and-earn" element={<RefernAndEarn />} />
        <Route path="/nas" element={<Nas />} />
        <Route path="/it-consulting" element={<ItConsulting />} />
        <Route path="/profile" element={<Profile />} />
        <Route path="/application-development" element={<ApplicationDevelopment />} />

        {/* 404 Catch-all */}
        <Route path="*" element={<NotFound />} />
        <Route path="/projects/:slug" element={<ProjectDetail />} />
      </Routes>
    </PageTransition>
  );
}

import { CartSidebar } from "./components/common/cart/CartSidebar";
import Social from "./pages/Social";

function AppContent() {
  const location = useLocation();
  const useDb = import.meta.env.VITE_USE_DB !== 'false';

  return (
    <>
      {useDb && <CartSidebar />}
      {/* {useDb || location.pathname === '/' && <Sidebar />} */}
      {location.pathname === '/' && <Sidebar />}
      <AppRoutes />
      <GoToTopButton />
    </>
  );
}

function App() {
  useSmoothScroll();
  const [loading, setLoading] = React.useState(true);

  return (
    <Router>
      <ScrollToTop />
      <AnimatePresence mode="wait">
        {loading && <Loader onLoadingComplete={() => setLoading(false)} />}
      </AnimatePresence>
      {!loading && (
          <AppContent />
      )}
    </Router>
  );
}

export default App;
